import axios from "axios";
import Config from "../../config/config";

const getListaPedidosAprovados = data => {
    return axios({
        method: "post",
        url: "https://api.katuxa.com.br/api/v1/apps/pdv/relatorios/vendas/getListaPedidosAprovados",
        data
    });
};

export default getListaPedidosAprovados;
